import {
  TABLE_BORDER,
  TABLE_INTERACTIVE,
  TABLE_ROW_EVEN,
  TABLE_ROW_HOVER,
  TABLE_ROW_ODD,
  TABLE_SUBTLE,
} from './tableStyles';

/**
 * Marco "tipo Card" (borde fino + esquinas redondeadas) que envuelve
 * cualquier tabla del report. Inyecta también las reglas CSS comunes:
 *
 *   .efftable-row              filas del body con stripe par/impar y
 *                              fondo más oscuro al pasar el ratón.
 *   td.efftable-sticky         celdas sticky-horizontal: heredan el
 *                              fondo del row para que stripe/hover se
 *                              propaguen.
 *   .efftable-link             link discreto en gris; al pasar el
 *                              ratón se ilumina en azul Polaris.
 *
 * El componente NO incluye el `overflow` interno — eso lo decide
 * cada tabla (algunas necesitan scroll vertical con max-height para
 * sticky thead/tfoot; otras sólo necesitan scroll-x).
 */
export const TableShell = ({ children }) => (
  <div
    style={{
      border: `1px solid ${TABLE_BORDER}`,
      borderRadius: 8,
      overflow: 'hidden',
      backgroundColor: TABLE_ROW_ODD,
    }}
  >
    <style>{`
      .efftable-row { background-color: ${TABLE_ROW_ODD}; }
      .efftable-row:nth-child(even) { background-color: ${TABLE_ROW_EVEN}; }
      .efftable-row:hover { background-color: ${TABLE_ROW_HOVER}; }
      td.efftable-sticky { background-color: inherit; }
      .efftable-link { color: ${TABLE_SUBTLE}; text-decoration: none; font-weight: 500; transition: color 120ms ease; }
      .efftable-link:hover { color: ${TABLE_INTERACTIVE}; text-decoration: underline; }
    `}</style>
    {children}
  </div>
);
